export default {
    methods: {
        getDifficulties() {
            return this.get(`/difficulty/index`);
        },
    }
}